<header class="c-header" [ngClass]="{'has-divider': divider, 'u-padding-bottom-1_5-rem': paddingBottom}">
  <h1 class="c-header__title">{{appTitle}}</h1>
  <div class="c-header__content">
    <p class="c-header__sub-titulo" *ngIf="subTitulo">{{subTitulo}}</p>
    <ng-content></ng-content>
  </div>
</header>